var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareProductProspector = function SvgYeswareProductProspector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1636_8711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0H10C4.477 0 0 4.477 0 10v15c0 5.523 4.477 10 10 10h15c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10Z",
    fill: "#E7F1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.977 23.619a7.61 7.61 0 0 0 4.835-1.726l4.56 4.559a.764.764 0 0 0 1.08-1.08l-4.56-4.56A7.643 7.643 0 1 0 9.106 12.63a7.643 7.643 0 0 0 6.872 10.989Zm-2.293-8.407h1.529v-1.529a.764.764 0 1 1 1.528 0v1.529h1.529a.764.764 0 0 1 0 1.528h-1.53v1.529a.764.764 0 1 1-1.528 0V16.74h-1.528a.764.764 0 1 1 0-1.528Z",
    fill: "#039BE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1636_8711"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35v35H0z"
  })))));
};
export default SvgYeswareProductProspector;